import { View, StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'


const Card = ({ header = undefined, footer = undefined, children }) => {

    return (
        <View
            style={ styles.container }>

            { header && (
                <View 
                    style={ styles.header }>
                    
                    { header() }
                </View>
            ) }

            <View
                style={ styles.content }>
                
                { children }
            </View>

            { footer && (
                <View
                    style={ styles.footer }>

                    { footer() }
                </View>
            ) }
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        
    },
    header: {
        padding: 16,
        paddingHorizontal: 24,
        borderBottomWidth: 1,
        borderBottomColor: colorList.GREY.primary,
    },
    content: {
        padding: 16,
        paddingHorizontal: 24,
    },
    footer: {
        padding: 16,
        paddingHorizontal: 24,
        borderTopWidth: 1,
        borderTopColor: colorList.GREY.primary,
    }
})

export default Card